export default {
    state: {
        type: "", // actve shape 的类型STR4
        id: 0, // activeshape的id
        fromLibId: 0, // 符号来自符号库id
        isMultiSel: false, // 是否是多选
        multiSelCount: 0, // 多选形状个数
        containOrgShape: false, // 是否包含orgshape 包含时禁用组合功能
        containLine: false, // 是否包含 connectline freeline ，包含时右侧 lineset 开启流向动画设置
        isLine: false, // 是否是线条之类的形状，是则不能插入note 等。
        isToolOperating: false, // 是否处于操作状态
        group: false, // 是否可group
        unGroup: false, // 是否可ungroup
        isGrouped: false, // 是否为组合形状
        childShape: 0, // 子形状个数
        isActived: false, // 是否actived obj
        isStyleBrushActive: false, // 是否选中格式刷
        hyperlinks: [], // 超链接 array.
        comments: [], // 评论 array. {name:string,date: string, msg: string}
        note: "", // note html.
        edimage: null, // 选中的EDMathImage
        layerID: 0, // 当前形状的layerID.
        themeActive: -1, // 快速主题
        canFill: false, // 是否可以填充
        canLine: false, // 是否可以线条
        canRotate: false, // 是否可以旋转
        canDrill: false, // 是否可以Drill.
        canToggle: false, // 是否可以Toggle.
        canStopDrill: false, // 是否可以停止Drill.
        canStopToggle: false, // 是否可以停止Toggle
        canFlip: false, // 是否可以翻转
        canResetCnt: false,
        canConvertCnt: false,
        isIgnJump: false,
        showIgnJump: false,
        isShowPhoto: false,
        isAllMMShape: false, // 是否是MMShape 多选。
        isMMShape: false, // 是否是mmshape
        isMMRelation: false, // 是否是mm关系线
        isSummary: false,
        isBoundary: false,

        isAllGanttShape: false, //是否甘特图多选
        isAllTableShape: false, //s

        isSelectGanttRow: false, //是否选择甘特图行
        isSelectGanttColumn: false, //是否选择甘特图列

        canCreateSmartShape: false, //是否可以创建smartshape
        depTint: false,
        width: 0,
        height: 0,
        xPos: 0,
        yPos: 0,
        angle: 0,
        WHRatio: false, //宽高比例固定

        lanes: 0, // 特殊设置泳道
        rows: 0, // 特殊设置行数
        columns: 0, // 特殊设置列数
        specialColor: [], // 特殊设置颜色
        isSelectLane: false, // 是否选中泳道
        isSelectSeparator: false, // 是否选中泳道分隔符
        isSelectSwimTitle: false, // 是否选中泳道大标题
        swimMainTitle: 0, // 是否显示泳道标题
        canMoveUpLane: false, // 是否可上移泳道
        canMoveDownLane: false, // 是否可下移泳道
        verticalLane: false, // 泳道是否水平排列
        canMerge: false, // 组合块
        canSplitH: false, // 水平分割块
        canSplitV: false, // 竖直分割块

        cardTitle: "", // 卡片标题
        cardDesc: "", // 卡片描述
        cardAssignee: "", // 卡片负责人
        cardDueDate: -1, // 卡片时间
        cardProgress: -1, // 卡片进度
        cardTagsText: [], // 卡片标签文本
        cardTagsColor: [], // 卡片颜色

        conLineType: null, // 连接线类型
        actionsList: [],
        // geometry:{
        //     xPos: 0, // number
        //     yPos: 0, // number
        //     angle: 0, // number
        //     width: 0, //number
        //     height: 0, //number，
        //     custom: [],// propertysheet in EDItem.
        // },
        fontFmt: {
            actived: false, //是否显示
            family: null,
            size: null,
            bold: false,
            italic: false,
            underline: false,
            strike: false,
            superscript: false,
            subscript: false,
            color: null,
            backClr: null,

            lineSpace: null,
            align: null,

            firstIndent: 0,
            leftIndent: 0,
            rightIndent: 0,
            before: 0,
            after: 0,
            isTextPath: false,
            dynamicUnit: "mm",
            maxIndent: 100,

            bulletStyle: -1, // 列表格式
            alpha: 1, // 文本颜色透明度
            index: 0,
            tint: 0,
        },
        fillFmt: {
            type: null, // ePaintType

            colors: [], // string[]
            tints: [], // tint[]
            alphas: [], // alphas[]

            angle: null, // 角度 number
            graIndex: null, // index
            patIndex: null, // index
            textureAlpha: null, // number 0-255
            textureIndex: null, // number
            textureFit: false, // boolean
            textureSrc: null, // base64 or bloburl
            offsets: [], // number[] 0-1;
        },
        lineFmt: {
            width: null, // 数字
            round: null, // 数字
            cap: null, // index 0:butt 1:square 2:round
            dash: null, // index
            startArrowId: null, //index
            startArrowSize: null, // 数字
            endArrowId: null, //index
            endArrowSize: null, // 数字

            type: null, // ePaintType

            colors: [], // string[]
            tints: [], // tint[]
            alphas: [], // alphas[]

            angle: null, // 角度
            graIndex: null, // index
            patIndex: null, // index
            offsets: [], // number[] 0-1;
        },
        shadowFmt: {
            type: null, // 枚举 0:none，1：outer,2:inner 3：perspective

            color: null, // string
            tint: null, // number
            alpha: null, // number

            size: null, // number
            blur: null, // number
            angle: null, // number
            offsetX: null, // number
            offsetY: null, //number
        },
        shapeData: [
            // 右侧面板形状属性数据
            // {
            //     id: 1,
            //     name: '属性0',
            //     type: 0,
            //     format: '@',
            //     value: '123',
            //     description: '123456',
            //     formatIndex: 0,
            //     decimalIndex: 0,
            //     currencyIndex: 0,
            //     unitIndex: 0,
            //     isCheck: false,
            // },
        ],
        lineAnimateData: {
            showAnime: false,
            animeStyle: 0,
            animeSpeed: 1,
            animeDensity: 1,
            animeColor: "",
            animeDirection: 0,
        },
        shapeDataID: -1,
        orgShapeCardData: [], // 组织结构图卡片信息数据（新增）
        planSet: {
            showType: "noShow",
            ratio: 0,
            wallThickness: 0,
            unit: 0,
            accuracy: 0,
        },
        hasText: false,
        activeText: "", // 单个选中形状的纯文本
        selectShapesFlag: "",
        messageID: 0,
        flowAnalyse: false,
        orgShapeAnalyse: false,
        echartSerieColors: [],
    },
    getters: {
        isSpecial: (state) => {
            let arr = ["TableUnit", "SwimContainer", "Matrix", "Entity", "EntityRow"];
            console.log(arr.includes(state.type));
            return arr.includes(state.type);
        },
        isOrgShape: (state) => {
            return state.type === "OrgShape";
        },
        isSwimlane: (state) => {
            return state.type === "SwimContainer";
        },
        isMatrix: (state) => {
            return state.type === "Matrix";
        },
        isFloorPlanWall: (state) => {
            return state.type === "FloorPlanWall";
        },
        isTableUnit: (state) => {
            return state.type === "TableUnit";
        },
        isTable: (state) => {
            return state.type === "Table";
        },
        isEntity: (state) => {
            return state.type === "Entity" || state.type === "EntityRow";
        },
        isEntityRow: (state) => {
            return state.type === "EntityRow";
        },
        isMultiBlock: (state) => {
            return state.type === "MultiBlock";
        },
        isConnectLine: (state) => {
            return state.type === "ConnectLine";
        },
        isImage: (state) => {
            return state.type === "Image" || state.type === "MathImage";
        },
    },
    mutations: {
        setShapeStatus(state, payload) {
            state[payload.type] = payload.data;
        },
        setShapeCombineStatus(state, payload) {
            Object.keys(payload).forEach((k) => {
                state[k] = payload[k];
            });
        },
        disActivedFmtType(state) {
            state.isMultiSel = false;
            if (!window["_view"]._activeShape) {
                state.isActived = false;
            }
            state.isAllMMShape = false;
            state.isAllGanttShape = false;
            state.isAllTableShape = false;
            state.group = false;
            state.fontFmt.actived = false;
            state.fillFmt.type = null;
            state.lineFmt.type = null;
            state.shadowFmt.type = null;
            state.type = null;
            state.xPos = null;
            state.yPos = null;
            state.height = null;
            state.width = null;
            state.canFill = false;
            state.canLine = false;
            state.id = 0;
            state.note = "";
            state.actionsList = [];
        },
        activedFillType(state, payload) {
            state.fillFmt.type = payload;
        },
        activedLineType(state, payload) {
            state.lineFmt.type = payload;
        },
        activedShadowType(state, payload) {
            state.shadowFmt.type = payload;
        },
        // setPropertyData(state,payload){
        //     state.geometry[payload.type] = payload.data;
        // },
        setFontFmtData(state, payload) {
            let type = payload.type;
            let data = payload.data;
            state.fontFmt[type] = data;
        },
        setFillFmtData(state, payload) {
            let type = payload.type;
            let data = payload.data;
            state.fillFmt[type] = data;
        },
        setLineFmtData(state, payload) {
            let type = payload.type;
            let data = payload.data;
            state.lineFmt[type] = data;
        },
        setShadowFmtData(state, payload) {
            let type = payload.type;
            let data = payload.data;
            state.shadowFmt[type] = data;
        },
        setFillColorData(state, payload) {
            let type = payload.type;
            let data = payload.data;
            let index = payload.index;
            state.fillFmt[type].splice(index, 1, data);
        },
        setLineColorData(state, payload) {
            let type = payload.type;
            let data = payload.data;
            let index = payload.index;
            state.lineFmt[type].splice(index, 1, data);
        },
        initPlanSetData(state, payload) {
            state.planSet.showType = payload.showType;
            state.planSet.ratio = payload.ratio;
            state.planSet.wallThickness = payload.wallThickness;
            state.planSet.showWall = payload.showWall;
            state.planSet.unit = payload.unit;
            state.planSet.accuracy = payload.accuracy;
            state.planSet.tag = payload.tag;
        },
        setPlanSetData(state, payload) {
            state.planSet[payload.type] = payload.data;
        },
        setShapeActions(state, payload) {
            state.actionsList = payload.data;
        },
        activedFont(state, payload) {
            state.fontFmt = payload;
        },
        activedFill(state, payload) {
            state.fillFmt = payload;
        },
        activedLine(state, payload) {
            state.lineFmt = payload;
        },
        activedShadow(state, payload) {
            state.shadowFmt = payload;
        },
        activedShapeData(state, payload) {
            state.shapeData = payload;
        },
        setEchartSeriesColors(state, payload) {
            state.echartSerieColors = payload;
        },
        activedLineAnimateData(state, payload) {
            state.lineAnimateData = payload;
        },
        setLineAnimateData(state, payload) {
            state.lineAnimateData[payload.type] = payload.data;
        },
    },
    actions: {},
};

export const combineCommitKeys = ["activeText", "isMultiSel", "flowAnalyse", "orgShapeAnalyse", "group", "unGroup"];
